module.exports = __webpack_public_path__ + "static/media/she.50e34300.mp3";